import { render, staticRenderFns } from "./IdiomSort.vue?vue&type=template&id=33925af8&scoped=true&"
import script from "./IdiomSort.vue?vue&type=script&lang=js&"
export * from "./IdiomSort.vue?vue&type=script&lang=js&"
import style0 from "./IdiomSort.vue?vue&type=style&index=0&id=33925af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33925af8",
  null
  
)

export default component.exports